module.exports = __webpack_public_path__ + "img/selected0-min.9baee1d1.png";